import * as React from 'react';

import Routing from 'containers/desktop/routing';

const DesktopContainer: React.FC = () => {
	return <Routing />;
};

export default DesktopContainer;
